import { type ReactNode } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { usePhotographerAuth } from "../../../contexts/PhotographerAuthContext";

interface Props { children: ReactNode; title?: string; }

export default function PhotographerLayout({ children, title }: Props) {
  const { session, logout } = usePhotographerAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/photographer/login", { replace: true });
  };

  const navLinkClass = (isActive: boolean) =>
    `flex items-center gap-1.5 text-xs font-light transition-colors cursor-pointer whitespace-nowrap ${
      isActive ? "text-[#2C2C2C]" : "text-[#2C2C2C]/40 hover:text-[#2C2C2C]/70"
    }`;

  return (
    <div className="min-h-screen bg-[#F7F6F3] flex flex-col">
      <header className="bg-white border-b border-[#D9D9D9]/60 px-8 py-4 flex items-center justify-between sticky top-0 z-10">
        <div className="flex items-center gap-4">
          <Link to="/photographer/dashboard" className="w-7 h-7 flex items-center justify-center rounded-full bg-[#C8B8A6]/20 text-[#C8B8A6] cursor-pointer">
            <i className="ri-camera-2-line text-sm" />
          </Link>
          <div className="flex items-center gap-1">
            <span className="text-xs font-light tracking-widest uppercase text-[#2C2C2C]/50">TaBiFoTo</span>
            <span className="mx-1 text-[#2C2C2C]/20">/</span>
            <span className="text-xs font-light text-[#2C2C2C]/70">攝影師入口</span>
          </div>
          <nav className="flex items-center gap-4 ml-4">
            <NavLink to="/photographer/dashboard" className={({ isActive }) => navLinkClass(isActive)}>
              <div className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-calendar-line text-xs" /></div>
              我的指派
            </NavLink>
            <NavLink to="/photographer/messages" className={({ isActive }) => navLinkClass(isActive)}>
              <div className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-message-2-line text-xs" /></div>
              訊息
            </NavLink>
          </nav>
        </div>
        <div className="flex items-center gap-4">
          {session && (
            <span className="text-xs font-light text-[#2C2C2C]/50">{session.display_name}</span>
          )}
          <button onClick={handleLogout}
            className="flex items-center gap-1.5 text-xs font-light text-[#2C2C2C]/40 hover:text-[#2C2C2C]/70 transition-colors cursor-pointer whitespace-nowrap">
            <div className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-logout-box-r-line" /></div>
            登出
          </button>
        </div>
      </header>
      <main className="flex-1 max-w-4xl w-full mx-auto px-6 py-8">
        {title && (
          <h1 className="text-xl font-light text-[#2C2C2C] tracking-wide mb-6">{title}</h1>
        )}
        {children}
      </main>
      <footer className="border-t border-[#D9D9D9]/40 px-8 py-4 text-center">
        <p className="text-[11px] font-light text-[#2C2C2C]/30 tracking-wide">TaBiFoTo — Photographer Portal</p>
      </footer>
    </div>
  );
}
